// extracted by mini-css-extract-plugin
export default {"d-flex":"d-flex__YMLdx","link":"link__zZmp1","external":"external__Mx-sr"};